import * as React from "react";
import { AdminEmail } from "src/sections";

export function NotFound(): JSX.Element {
    return (
        <div className="flex-vertical text-align-center ma-2 gap-2">
            <h2 className="white-text">404 - Page Not Found</h2>

            <div className="basic-box flex-vertical">
                <p className="white-text">
                    If this unexpected and the error persists you can contact the web admin:
                </p>
                <p>
                    <AdminEmail />
                </p>
            </div>
        </div>
    );
}
